import './Separator.less';

export default () => {
  return <div className="separator" />;
};
